import type { RootState } from 'store';

/**
 * Every `getEventDetails` cache key the event may be stored under (HNS-238).
 *
 * The signal that the event started carries the NUMERIC event id (a WS payload, or the id the
 * `startEvent` mutation was called with), but the cache is keyed by the exact arg the page fetched
 * with — and that key is type-sensitive, so `{"id":"123"}` is a different entry from `{"id":123}`.
 * The details/join pages pass the raw route param (`useRawEventDetailsLoader`), which is the UUID
 * publicId or a *stringified* numeric id (HNS-148), never a number; only the live-meeting routes
 * fetch by the numeric id. Patching by the numeric id alone therefore missed the entry the page was
 * actually reading, which is why the Join button stayed disabled until a manual refresh.
 *
 * `activeEventFetchId` is that key verbatim (`meta.arg.originalArgs.id`, original type preserved), so
 * including it covers every id style. A patch against a key with no entry is a harmless no-op.
 */
export const getEventDetailsCacheIds = (state: RootState, eventId: number): (string | number)[] => {
  const { activeEventId, activeEventFetchId } = state.event;
  const isActiveEvent = activeEventId === eventId && activeEventFetchId != null;

  return isActiveEvent && activeEventFetchId !== eventId ? [eventId, activeEventFetchId] : [eventId];
};
